import { render, staticRenderFns } from "./EventImage.vue?vue&type=template&id=4ada93e0&scoped=true"
import script from "./EventImage.vue?vue&type=script&lang=js"
export * from "./EventImage.vue?vue&type=script&lang=js"
import style0 from "./EventImage.vue?vue&type=style&index=0&id=4ada93e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ada93e0",
  null
  
)

export default component.exports